import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import LoadingIndication from '../../common/loading-indicator';

import TeamMemberBox from '../../common/team-member-box';
import Button from '../../common/button/button';

import facebook from '../../../assets/images/facebook-badge.svg';
import linkedin from '../../../assets/images/linkedin-badge.svg';
import twitter from '../../../assets/images/twitter-badge.svg';

import './community-section.css';

export default class CommunitySection extends Component {
  render() {
    let extraJSX;

    const { 
      facebookMembersCount, 
      linkedinMembersCount,
      twitterMembersCount, 
    } = this.props.communities || {};

    const communities = [{
      name: 'Facebook Group',
      linkUrl: 'https://www.facebook.com/groups/angular2typescript',
      title: facebookMembersCount && `${facebookMembersCount / 1000 }k Members` || '',
      badge: facebook,
    }, {
      name: 'Linkedin Group',
      linkUrl: 'https://www.linkedin.com/groups/7053365',
      title: linkedinMembersCount && `${linkedinMembersCount / 1000 }k Members` || '',
      badge: linkedin,
    }, {
      name: 'Twitter',
      linkUrl: 'https://www.twitter.com/DorMoshe',
      title: twitterMembersCount && `${twitterMembersCount / 1000 }k Followers` || '',
      badge: twitter,
    }];
    
    return (
      <section className={ `${ this.props.className } section-container communities-section-container` }>
        <h3 className='section-title'>
          Join Our Communities
        </h3>

        <div className='communities-container'>
          <div className='communities'>
            {
              communities.map((community, i) => 
                <div key={ `community-${i}` } className='little-grow-animation community'>
                  <CommunityBox { ...community } />
                </div>
              )
            }
          </div>

          <Link to='/community' title='Community'>
            <Button 
              label='Explore More' 
              isDark={ this.props.className !== 'dark' } />
          </Link>     
        </div>
      </section>
    );
  }
}

function CommunityBox({ name, linkUrl, title, badge, }) {
  return (
    <div className='community-box'>
      <a href={ linkUrl } title={ name } target='_blank'>
        <div className='community-badge'>
          <img 
            src={ badge } 
            title={ name } 
            alt={ name } />
        </div>

        <div className='community-title'>{ title }</div>
      </a>
    </div>
  );
}